import React from 'react';

import ResponsiveAppBar from './TopBar'
import { Box, Paper, Portal, Typography } from '@mui/material';

import Client from './components/Client';
import Config from './components/ClientConfig';
import CircularProgress from '@mui/material/CircularProgress';
import { flushSync } from 'react-dom';

import Stats from './Stats';
import Products from './Products';
import Combos from './Combos';
import Categories from './Categories';
import Classes from './Classes';
import Profile from './Profile';
import Locations from './Locations';
import LocationsGroups from './LocationsGroups';
import LocationExternalReferences from './LocationExternalReferences';
import Employees from './Employees';

import ListsPrice from './ListsPrice';
import MarketplaceOperations from './MarketplaceOperations';
import ListsPromotion from './ListsPromotion';
import ListsCompany from './ListsCompany';
import ListsProduct from './ListsProduct';
import ListsCombo from './ListsCombo';
import ListsAcquisition from './ListsAcquisition';
import UsersInternal from './UsersInternal';
import UsersClients from './UsersClients';
import Persons from './Persons';
import Companies from './Companies';

import ConfigPlatform from './ConfigPlatform';
import ConfigSalesApp from './ConfigSalesApp';
import ConfigMobileApp from './ConfigMobileApp';
import ConfigMobileIdentity from './ConfigMobileIdentity';
import ConfigWebsite from './ConfigWebsite';
import ConfigWebsiteIdentity from './ConfigWebsiteIdentity';
import ConfigIdentity from './ConfigIdentity';
import ConfigFeedback from './ConfigFeedback';
import ConfigProduct from './ConfigProduct';

import Recommendations from './Recommendations';
import Promotions from './Promotions';
import DirectPromotions from './DirectPromotions';
import ClientCreditManagement from './ClientCreditManagement';
import ClientPromotionClaims from './ClientPromotionClaims';
import NewsList from './NewsList';
import MessagesList from 'MessagesList';
import SkipTheLinePage from 'components/biReports/skipLine';

import ClientsAccounts from './ClientsAccounts';
import ClientsFamilies from './ClientsFamilies';
import ClientsProfessionals from './ClientsProfessionals';

import RapClients from './RapClients';
import RapClientsActivity from './RapClientsActivity';
import RapPromotions from './RapPromotions';
import RapSales from './RapSales';
import RapCommercialAnalysis from './RapCommercialAnalysis';
import RapSales2 from './RapSales2';
import RapProducts from './RapProducts';
import RapProducts2 from './RapProducts2';
import RapOrders from './RapOrders';
import RapTransactions from './RapTransactions';
import InventoryCloseTabs from './RapMonthClose';
import InventoryCostTabs from './RapProdCost';
import InventorySupplyTabs from './RapProdSupply';
import LocationOrdersPage from './RapLocOrders';
import OrderFeedbackView from 'components/biReports/sOrderFeedbackView';

import OperatorAuditLogs from './LogsPOS';
import PlatformLogs from './LogsPlatform';

import './css/sideBar.scss';
import './css/dashboard.css';

import SideBar from './components/SideBar';

import Visibility from './Visibility';


/* let theme = createTheme();

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    //marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  large: {
    //width: theme.spacing(20),
    //height: theme.spacing(20),
  },
})); */

//const classes = useStyles();

//export default function Dashboard() {

class Dashboard extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      client: new Client ( "none" ),
      mainContent: "stats",
      mainContentElement: "",
      sideBar_collapsed: false,
      geoData: {},
      hideSideBar: false,
      pageBusy: false,
      isMobile: false,
    };

    this.restricted = new Visibility ("dashboard");

    this.toggleSideCollapsed = this.toggleSideCollapsed.bind(this);
    this.setActiveContent = this.setActiveContent.bind(this);
    this.toggleSideBarCollapsed = this.toggleSideBarCollapsed.bind(this);
    this.pageReady = this.pageReady.bind(this);
    this.showPageOverlay = this.showPageOverlay.bind(this);
    this.hidePageOverlayMin = this.hidePageOverlayMin.bind(this);
    this._pageShownAt = 0;
    this._pageFallbackTimer = null;

  }
  //console.log ( "-- Dashboard -- " );
  //const classes = useStyles();
  //const [anchorEl, setAnchorEl] = React.useState(null);
  //const open = Boolean(anchorEl);

  /* let sUser = '{ "fname":"Bula", "lname":"Ionel" }';
  const user = JSON.parse(sUser); */

  componentDidMount() {
    //this.handleProfile ( );
    /* let queryData = {
      "status" : 2
    } */
    let queryData = {}
    let data = this.state.client.getGeoData (  );
    this.setState ( { geoData: data });

    queryData[ "orderBy" ] = "countryName";
    let lData = this.state.client.getData ( Config.API_URL_LANGUAGE, queryData );
    this.setState ( { languages: lData.Languages } );

    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
  }

  resize() {
    const isMobile = window.innerWidth <= 760;

    this.setState((prevState) => {
      if (isMobile) {
        return {
          isMobile: true,
          hideSideBar: true,
          sideBar_collapsed: false,
        };
      }

      return {
        isMobile: false,
        hideSideBar: false,
        sideBar_collapsed: prevState.sideBar_collapsed,
      };
    });
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resize.bind(this));
  }

  showPageOverlay() {
    // Turn on overlay, then wait for paint before starting the timer
    this.setState({ pageBusy: true }, async () => {
      await new Promise(requestAnimationFrame);
      await new Promise(requestAnimationFrame); // extra-safe
      this._pageShownAt = performance.now();
    });
  }

  hidePageOverlayMin() {
    const MIN_VISIBLE = 400; // ms: avoids blink
    const elapsed = performance.now() - (this._pageShownAt || 0);
    const doHide = () => this.setState({ pageBusy: false });

    if (elapsed < MIN_VISIBLE) {
      setTimeout(doHide, MIN_VISIBLE - elapsed);
    } else {
      doHide();
    }
  }

  pageReady() {
    // Called by child pages when they are mounted / finished loading
    if (this._pageFallbackTimer) {
      clearTimeout(this._pageFallbackTimer);
      this._pageFallbackTimer = null;
    }
    this.hidePageOverlayMin();
  }

  toggleSideCollapsed ( collapsed ) {
    this.setState({ sideBar_collapsed: collapsed });
  }

  setActiveContent = async (nextKey) => {
    // 1) Show the overlay and commit it synchronously
    flushSync(() => this.setState({ pageBusy: true }));

    // 2) Let the browser paint the overlay before we mount the new page
    await new Promise(requestAnimationFrame);
    await new Promise(requestAnimationFrame);
    this._pageShownAt = performance.now(); // mark visible time for min-duration

    // 3) Now switch the page
    this.setState(
      {
        mainContent: nextKey,
        hideSideBar: this.state.isMobile ? true : this.state.hideSideBar,
      },
      () => {
        // Fallback: if the page doesn't call onReady, hide after ~1.2s
        if (this._pageFallbackTimer) clearTimeout(this._pageFallbackTimer);
        this._pageFallbackTimer = setTimeout(() => this.hidePageOverlayMin(), 1200);
      }
    );
  };

  // keep your min-duration hide helper
  hidePageOverlayMin = () => {
    const MIN_VISIBLE = 400; // avoid blink
    const elapsed = performance.now() - (this._pageShownAt || 0);
    const doHide = () => this.setState({ pageBusy: false });
    if (elapsed < MIN_VISIBLE) setTimeout(doHide, MIN_VISIBLE - elapsed);
    else doHide();
  };

  toggleSideBarCollapsed(state) {
    this.setState((prevState) => {
      if (prevState.isMobile) {
        return {
          hideSideBar: !prevState.hideSideBar,
          sideBar_collapsed: false,
        };
      }

      return {
        sideBar_collapsed: true,
        hideSideBar: !state,
      };
    });
  }

  render() {
    if (!this.restricted.scope.visible)
      return (<div></div>);

    const commercialPage = this.state.mainContent === 'rap_commercial_analysis';
    const commercialMobile = commercialPage && this.state.isMobile;
    let mainContentElement;
    switch ( this.state.mainContent ) {
      case "stats":
        mainContentElement = <Stats onReady={this.pageReady} />;
        break;
      case "profile":
        mainContentElement = <Profile onReady={this.pageReady} />;
        break;
      case "products":
        mainContentElement = <Products onReady={this.pageReady} />;
        break;
      case "combos":
        mainContentElement = <Combos onReady={this.pageReady} />;
        break;
      case "categories":
        mainContentElement = <Categories onReady={this.pageReady} />;
        break;
      case "classes":
        mainContentElement = <Classes onReady={this.pageReady} />;
        break;
      case "locations":
        mainContentElement = <Locations geoData={this.state.geoData} onReady={this.pageReady} />;
        break;
      case "locations_groups":
        mainContentElement = <LocationsGroups geoData={this.state.geoData} onReady={this.pageReady} />;
        break;
      case "locations_external_references":
        mainContentElement = <LocationExternalReferences onReady={this.pageReady} />;
        break;
      case "employees":
        mainContentElement = <Employees geoData={this.state.geoData} onReady={this.pageReady} />;
        break;

      case "marketplace":
        mainContentElement = <MarketplaceOperations onReady={this.pageReady} />;
        break;
      case "listsPrice":
        mainContentElement = <ListsPrice geoData={this.state.geoData} onReady={this.pageReady} />;
        break;
      case "listsPromotion":
        mainContentElement = <ListsPromotion geoData={this.state.geoData} onReady={this.pageReady} />;
        break;
      case "listsCompany":
        mainContentElement = <ListsCompany geoData={this.state.geoData} onReady={this.pageReady} />;
        break;
      case "listsProduct":
        mainContentElement = <ListsProduct geoData={this.state.geoData} onReady={this.pageReady} />;
        break;
      case "listsCombo":
        mainContentElement = <ListsCombo geoData={this.state.geoData} onReady={this.pageReady} />;
        break;
      case "listsAcquisition":
        mainContentElement = <ListsAcquisition geoData={this.state.geoData} onReady={this.pageReady} />;
        break;

      case "recommendations":
        mainContentElement = <Recommendations geoData={this.state.geoData} onReady={this.pageReady} />;
        break;
      case "promotions":
        mainContentElement = <Promotions geoData={this.state.geoData} onReady={this.pageReady} />;
        break;
      case "directPromo":
        mainContentElement = <DirectPromotions geoData={this.state.geoData} onReady={this.pageReady} />;
        break;
      case "clientCredit":
        mainContentElement = <ClientCreditManagement geoData={this.state.geoData} onReady={this.pageReady} />;
        break;
      case "clientPromotionClaims":
        mainContentElement = <ClientPromotionClaims onReady={this.pageReady} />;
        break;
      case "news":
        mainContentElement = <NewsList geoData={this.state.geoData} onReady={this.pageReady} />;
        break;
      case "message":
        mainContentElement = <MessagesList geoData={this.state.geoData} onReady={this.pageReady} />;
        break;
      case "order":
        mainContentElement = <SkipTheLinePage geoData={this.state.geoData} onReady={this.pageReady} />;
        break;
      case "rap_locorders":
        mainContentElement = <LocationOrdersPage onReady={this.pageReady} />;
        break;
      case "feedback":
        mainContentElement = <OrderFeedbackView onReady={this.pageReady} />;
        break;

      case "usersInternal":
        mainContentElement = <UsersInternal geoData={this.state.geoData} onReady={this.pageReady} />;
        break;

      case "usersClients":
        mainContentElement = <UsersClients geoData={this.state.geoData} onReady={this.pageReady} />;
        break;

      case "addressBook_persons":
        mainContentElement = <Persons geoData={this.state.geoData} onReady={this.pageReady} />;
        break;

      case "addressBook_companies":
        mainContentElement = <Companies geoData={this.state.geoData} onReady={this.pageReady} />;
        break;

      case "config_platform":
        mainContentElement = <ConfigPlatform onReady={this.pageReady} />;
        break;
      case "config_salesapp":
        mainContentElement = <ConfigSalesApp onReady={this.pageReady} />;
        break;
      case "config_mobileapp":
        mainContentElement = <ConfigMobileApp onReady={this.pageReady} />;
        break;
      case "config_mobile_identity":
        mainContentElement = <ConfigMobileIdentity languages={this.state.languages} onReady={this.pageReady} />;
        break;
      case "config_website":
        mainContentElement = <ConfigWebsite onReady={this.pageReady} />;
        break;
      case "config_website_identity":
        mainContentElement = <ConfigWebsiteIdentity languages={this.state.languages} onReady={this.pageReady} />;
        break;
      case "config_identity":
        mainContentElement = <ConfigIdentity languages={this.state.languages} onReady={this.pageReady} />;
        break;
      case "config_feedback":
        mainContentElement = <ConfigFeedback languages={this.state.languages} onReady={this.pageReady} />;
        break;
      case "config_product":
        mainContentElement = <ConfigProduct languages={this.state.languages} onReady={this.pageReady} />;
        break;

      case "logs_pos":
        mainContentElement = <OperatorAuditLogs onReady={this.pageReady} />;
        break;
      case "logs_platform":
        mainContentElement = <PlatformLogs onReady={this.pageReady} />;
        break;
      case "clientsAccounts":
        mainContentElement = <ClientsAccounts geoData={this.state.geoData} onReady={this.pageReady} />
        break;
      case "clientsFamilies":
        mainContentElement = <ClientsFamilies onReady={this.pageReady} />;
        break;
      case "clientsProfessionals":
        mainContentElement = <ClientsProfessionals onReady={this.pageReady} />;
        break;

      case "rap_sales":
          mainContentElement = <RapSales onReady={this.pageReady} />;
          break;
      case "rap_commercial_analysis":
        mainContentElement = <RapCommercialAnalysis onReady={this.pageReady} mobileLayout={commercialMobile} />;
        break;
      case "rap_sales2":
            mainContentElement = <RapSales2 onReady={this.pageReady} />;
            break;
      case "rap_products":
            mainContentElement = <RapProducts onReady={this.pageReady} />;
            break;
      case "rap_products2":
        mainContentElement = <RapProducts2 onReady={this.pageReady} />;
        break;
      case "rap_orders":
        mainContentElement = <RapOrders onReady={this.pageReady} />;
        break;
      case "rap_clients":
        mainContentElement = <RapClients onReady={this.pageReady} />;
        break;
      case "rap_clientsActivity":
        mainContentElement = <RapClientsActivity onReady={this.pageReady} />;
        break;
      case "rap_promotion":
        mainContentElement = <RapPromotions onReady={this.pageReady} />;
        break;
      case "rap_trans":
        mainContentElement = <RapTransactions onReady={this.pageReady} />;
        break;
      case "rap_close":
        mainContentElement = <InventoryCloseTabs onReady={this.pageReady} />;
        break;
      case "rap_cost":
        mainContentElement = ( <InventoryCostTabs onReady={this.pageReady} />);
        break;
      case "rap_supply":
        mainContentElement = <InventorySupplyTabs onReady={this.pageReady} />;
        break;
 
    }

    /* const content=[
      {
          icon: 'icon-class-name',
          label: 'Label of Item',
          to: '#a-link',
      },
      {
          icon: 'icon-class-name',
          label: 'Second Item',
          content: [
              {
                  icon: 'icon-class-name',
                  label: 'Sub Menu of Second Item',
                  to: '#another-link',
              },
          ],
      },
    ];
 */
    

    //const showSidebar = () => setSidebar(!sidebar);
    //const { sideCollapsed, setSideCollapsed } = this.state;

    let mainContentMarginLeft = "160px";
    if (this.state.sideBar_collapsed) mainContentMarginLeft = "50px";
    if (this.state.hideSideBar || this.state.isMobile) mainContentMarginLeft = "0px";

    return (

      <>
        <style>{`
          /* Hide scrollbars for react-pro-sidebar */
          .pro-sidebar,
          .pro-sidebar-inner,
          .pro-sidebar-layout,
          .pro-menu {
            scrollbar-width: none !important; /* Firefox */
          }

          .pro-sidebar::-webkit-scrollbar,
          .pro-sidebar-inner::-webkit-scrollbar,
          .pro-sidebar-layout::-webkit-scrollbar,
          .pro-menu::-webkit-scrollbar {
            width: 0 !important;
            height: 0 !important;
            display: none !important; /* Chrome, Edge, Safari */
          }
        `}</style>
 
        <div style={{ backgroundColor: "#273442", height: commercialPage ? '100dvh' : '100vh', overflowX: "hidden", ...(commercialPage ? { overflowY: 'hidden' } : {}) }}>

          <div className="topBar">
            <ResponsiveAppBar
              toggleSideBarCollapsed = {this.toggleSideBarCollapsed}
              setActiveContent = {this.setActiveContent}
            />
          </div>
          
          {!this.state.hideSideBar && !this.state.isMobile ? (
            <SideBar
              toggleSideCollapsed={this.toggleSideCollapsed}
              setActiveContent={this.setActiveContent}
              activeContent={this.state.mainContent}
            />
          ) : ""}

          {!this.state.hideSideBar && this.state.isMobile ? (
            <Box
              sx={{
                position: 'fixed',
                top: '64px',
                left: 0,
                bottom: 0,
                width: 'min(88vw, 320px)',
                zIndex: 1199,
                overflowY: 'auto',
                overflowX: 'hidden',
                bgcolor: 'transparent',
                boxShadow: 'none',

                '& .pro-sidebar': {
                  width: '100% !important',
                  minWidth: '100% !important',
                  maxWidth: '100% !important',
                },

                '& .pro-sidebar-inner': {
                  width: '100% !important',
                },
              }}
            >
              <SideBar
                toggleSideCollapsed={this.toggleSideCollapsed}
                setActiveContent={this.setActiveContent}
                activeContent={this.state.mainContent}
              />
            </Box>
          ) : ""}
          
          <div className="mainContent" style={{
            marginLeft: mainContentMarginLeft,
            marginTop: this.state.mainContent === 'rap_clients' ? 0 : '10px',
            ...(this.state.mainContent === 'rap_clients' ? { paddingTop: 0 } : {}),
            ...(this.state.mainContent === 'marketplace' ? {
              marginTop: 0, padding: '64px 0 0', minHeight: '100vh',
              boxSizing: 'border-box',
            } : {}),
            ...(commercialPage ? {
              marginTop: 0, padding: commercialMobile ? '48px 0 0' : '48px 2em 0', height: '100dvh',
              boxSizing: 'border-box', overflow: 'hidden',
            } : {}),
          }}>
            { mainContentElement }
          </div>

          <Portal>
            {this.state.pageBusy && (
              <Box
                role="status"
                aria-live="polite"
                sx={{
                  position: 'fixed', inset: 0, zIndex: 2000,
                  // simple dim – cheap to render
                  bgcolor: 'rgba(0,0,0,0.12)',
                  // optional vignette for focus (still cheap; no blur)
                  backgroundImage: 'radial-gradient(ellipse at center, rgba(0,0,0,0.10) 0%, rgba(0,0,0,0.18) 70%, rgba(0,0,0,0.22) 100%)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  pointerEvents: 'auto',
                }}
              >
                <Paper
                  elevation={3}  // small shadow only
                  sx={{
                    px: 2.5, py: 1.5, borderRadius: 2,
                    bgcolor: 'background.paper',
                    color: 'text.primary',
                    display: 'flex', alignItems: 'center', gap: 1.25,
                    // avoid heavy effects: no blur, no large box-shadows
                    // use transform compositing for smoother paint of the card
                    transform: 'translateZ(0)',
                  }}
                >
                  <CircularProgress size={22} color="inherit" />
                  <Typography variant="body2">Loading…</Typography>
                </Paper>
              </Box>
            )}
          </Portal>

        </div>

      </>

      /* </ThemeProvider> */
    );
  }
}

export default Dashboard;
